import { SpaceType } from './configurations'

export interface CategoryGroup {
  label: string
  types: SpaceType[]
}

export const categoryGroups: Record<string, CategoryGroup> = {
  'meeting-rooms-and-day-passes': {
    label: 'Meeting Rooms and Day Passes',
    types: ['meeting_room', 'day_pass'],
  },
  workspaces: {
    label: 'Workspaces',
    types: ['office', 'suite'],
  },
  events: {
    label: 'Events',
    types: ['event_space'],
  },
}

/**
 * Get category group by key
 */
export const getCategoryGroup = (key: string): CategoryGroup | undefined => {
  return categoryGroups[key]
}

/**
 * Get category group key by types array
 */
export const getCategoryGroupKeyByTypes = (types: SpaceType[]): string | undefined => {
  const sortedTypes = [...types].sort().join(',')
  for (const [key, group] of Object.entries(categoryGroups)) {
    const groupSortedTypes = [...group.types].sort().join(',')
    if (sortedTypes === groupSortedTypes) {
      return key
    }
  }
  return undefined
}

/**
 * Get the category group that contains a specific space type
 */
export const getCategoryGroupByType = (type: SpaceType): CategoryGroup | undefined => {
  for (const group of Object.values(categoryGroups)) {
    if (group.types.includes(type)) {
      return group
    }
  }
  return undefined
}

/**
 * Check if two types belong to the same category group
 */
export const areTypesInSameGroup = (type1: SpaceType, type2: SpaceType): boolean => {
  const group1 = getCategoryGroupByType(type1)
  const group2 = getCategoryGroupByType(type2)
  return group1 !== undefined && group2 !== undefined && group1 === group2
}
